import "../stats.css";

const stats = [
    { number: "250+", label: "Projects Completed" },
    { number: "15+", label: "Years Experience" },
    { number: "98%", label: "Client Satisfaction" },
    { number: "50+", label: "Expert Team" }
];

function Stats() {
    return (
    <div className="stats">
        {stats.map((s, i) => (
        <div className="stat-card" key={i}>
            <h2>{s.number}</h2>
            <p>{s.label}</p>
        </div>
        ))}
    </div>
    );
}

export default Stats;